import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { auth, functions } from '../firebase/config';
import { onAuthStateChanged } from 'firebase/auth';
import { httpsCallable } from 'firebase/functions';

const AppContext = createContext();

export const useAppContext = () => useContext(AppContext);

export const AppProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [userData, setUserData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const fetchInitialUserData = useCallback(async () => {
        if (auth.currentUser) {
            try {
                const getInitialUserData = httpsCallable(functions, 'getInitialUserData');
                const result = await getInitialUserData();
                setUserData(result.data);
            } catch (error) {
                console.error("Error fetching initial user data:", error);
            }
        }
    }, []);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setUser(user);
            if (user && user.emailVerified) {
                fetchInitialUserData().then(() => setIsLoading(false));
            } else {
                setUserData(null);
                setIsLoading(false);
            }
        });
        return () => unsubscribe();
    }, [fetchInitialUserData]);

    const value = {
        user,
        userData,
        isLoading,
        isProfileComplete: userData?.profile?.profileComplete || false,
        refreshUserData: fetchInitialUserData,
    };

    return (
        <AppContext.Provider value={value}>
            {children}
        </AppContext.Provider>
    );
};